import { jsonHttpClient as httpClient, getApiUrl } from '../http-client'

const authKey = 'haulzUser'
const resource = 'sessions'

const authProvider = () => {
  const url = getApiUrl(resource)

  const login = async (params) => {
    const json = await httpClient.post(url, params)
    const { data } = json
    setAuth(data)
  }

  const logout = async () => {
    await httpClient.delete(url)
    removeAuth()
  }

  const setAuth = (data = {}) => localStorage.setItem(authKey, JSON.stringify(data))

  const removeAuth = () => {
    localStorage.removeItem(authKey)
  }

  const isAuthenticated = async () => {
    return Boolean(localStorage.getItem(authKey))
  }

  const getUser = () => {
    try {
      return JSON.parse(localStorage.getItem(authKey))
    } catch {
      return null
    }
  }

  return {
    login: async ({ username, password }) => {
      const postData = {
        username,
        password,
      }
      return login(postData)
    },

    checkError: async error => {
      const { status } = error
      if (status === 401) {
        removeAuth()
        return Promise.reject()
      }
    },

    checkAuth: async params => {
      const authenticated = await isAuthenticated()
      if (!authenticated) {
        return Promise.reject()
      }
    },

    logout,

    getIdentity: async () => {
      const user = getUser()
      if (!user) {
        return {}
      }
      return {
        id: user.id,
        fullName: user.username,
      }
    },

    getPermissions: async () => {
      const resp = await httpClient.get(getApiUrl('permissions'))
      return resp.data
    },

    handleCallback: async () => {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token')
      const newUrl = new URL(window.location)
      newUrl.searchParams.delete('token')
      window.history.replaceState({}, '', newUrl.pathname + newUrl.search)

      if (!token) return
      try {
        await logout()
        await login({ token })
      } catch (error) {
        return { redirectTo: '/login' }
      }
    },
  }
}

export default authProvider

export { authKey }
